import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';

import { getRole } from '../../../../../redux/auth/selectors';
import { USER_ROLES } from '../../../../../utils/constants';
import Checkbox from '../../../../../components/inputs/checkbox-item';
import { REPORT_STATUS, getFlaggedVersion, patchReportVersionSuccess } from '../../../../../redux/reports';
import { getCurrentReport } from '../../../../../redux/current-report/selectors';

const QuestionWrapper = ({ render, questionId, questionType, classes }) => {
    const dispatch = useDispatch();
    const role = useSelector(getRole);
    const report = useSelector(getCurrentReport);
    const flaggedVersion = getFlaggedVersion(report);
    const { flaggedAnswers } = flaggedVersion;
    const reason = flaggedAnswers && flaggedAnswers[questionId]?.reason;
    const isFlagged = flaggedAnswers && !!flaggedAnswers[questionId];

    const handleCheck = (event) => {
        const { checked } = event.target;
        if (checked) {
            dispatch(patchReportVersionSuccess(
                report.id,
                flaggedVersion.id,
                {
                    flaggedAnswers: {
                        ...flaggedAnswers,
                        [questionId]: { reason: '' },
                    },
                },
            ));
        } else {
            const { [questionId]: removed, ...rest } = flaggedAnswers;
            dispatch(patchReportVersionSuccess(
                report.id,
                flaggedVersion.id,
                {
                    flaggedAnswers: rest,
                },
            ));
        }
    };

    const handleReasonChange = (event) => {
        const { value } = event.target;
        dispatch(patchReportVersionSuccess(
            report.id,
            flaggedVersion.id,
            {
                flaggedAnswers: {
                    ...flaggedAnswers,
                    [questionId]: {
                        ...flaggedAnswers[questionId],
                        reason: value,
                    },
                },
            },
        ));
    };

    if (role === USER_ROLES.tester.value) {
        return report.status === REPORT_STATUS.REOPENED ? (
            <div>
                {render({ disabled: !isFlagged })}
                {!!reason && (
                    <Box className={classes.reanswerRequestReason}>
                        <p className={classes.inputLabel} style={{ marginTop: 0, marginBottom: 5 }}>Reason for re-answer request</p>
                        {reason}
                    </Box>
                )}
            </div>
        ) : (
            render({ disabled: false })
        );
    }

    return (
        <Grid item container>
            <Grid item xs={1} mr={2}>
                {questionType !== 'instructions' && (
                    <Checkbox
                        name={`flagged-${questionId}`}
                        inputProps={{ 'aria-label': 'Flag question for review' }}
                        value={isFlagged?.toString() || 'false'}
                        isChecked={isFlagged}
                        onChange={handleCheck}
                    />
                )}
            </Grid>
            <Grid item xs>
                {render({ disabled: true })}
                {isFlagged && (
                    <Box pt={2}>
                        <FormLabel className={classes.inputLabel}>
                            Reason for re-answer request (required)
                        </FormLabel>
                        <div>
                            <textarea
                                rows={4}
                                className={classes.textAreaBlock}
                                onChange={handleReasonChange}
                                value={flaggedAnswers[questionId]?.reason || ''}
                                style={{ width: '100%' }}
                            />
                            <FormHelperText error>{flaggedAnswers[questionId]?.error}</FormHelperText>
                        </div>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
};

QuestionWrapper.propTypes = {
    render: PropTypes.func.isRequired,
    questionId: PropTypes.string.isRequired,
    questionType: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default QuestionWrapper;
